import { useContext } from 'react';
import { WidgetContainer } from '@/core/widgets/model/widget-container';
import { WidgetContainerContext } from '@/core/widgets/contexts/widget-container-context';
import { WidgetHost } from '@/core/widgets/model/widget-host';
import { WidgetHostContext } from '@/core/widgets/contexts/widget-host-context';

interface WidgetPreferencesService<T> {
  getWidgetPreferences(id?: string): Promise<T | null>;
  saveWidgetPreferences(p: T, id?: string): Promise<T>;
  preferencesKey: string;
}

export default function useWidgetPreferences<T>(): WidgetPreferencesService<T> {
  const { widgetId } = useContext<WidgetContainer>(WidgetContainerContext);
  const { hostId, currentViewId, getWidgetPreferences, saveWidgetPreferences } =
    useContext<WidgetHost>(WidgetHostContext);
  const preferencesKey = `widget-preferences-${hostId}-${currentViewId}-${widgetId}`;

  return {
    async getWidgetPreferences(id?: string): Promise<T | null> {
      return getWidgetPreferences<T>((id ?? widgetId) || '');
    },
    async saveWidgetPreferences(p: T, id?: string): Promise<T> {
      return saveWidgetPreferences<T>((id ?? widgetId) || '', p);
    },
    preferencesKey,
  };
}
